import MDTypography from "components/MDTypography";
import { IconButton, Box } from "@mui/material";
import BatteryFullIcon from "@mui/icons-material/BatteryFull";
import Battery90Icon from "@mui/icons-material/Battery90";
import Battery80Icon from "@mui/icons-material/Battery80";
import Battery60Icon from "@mui/icons-material/Battery60";
import Battery50Icon from "@mui/icons-material/Battery50";
import Battery30Icon from "@mui/icons-material/Battery30";
import Battery20Icon from "@mui/icons-material/Battery20";
import BatteryAlertIcon from "@mui/icons-material/BatteryAlert";

function CTLBatteryStatus({ value }) {
  const batteryValue = value ?? 0;

  const getBatteryDetails = (level) => {
    if (level > 90) {
      return { color: "limegreen", icon: <BatteryFullIcon fontSize="medium" /> };
    } else if (level > 80) {
      return { color: "limegreen", icon: <Battery90Icon fontSize="medium" /> };
    } else if (level > 70) {
      return { color: "limegreen", icon: <Battery80Icon fontSize="medium" /> };
    } else if (level > 50) {
      return { color: "gold", icon: <Battery60Icon fontSize="medium" /> };
    } else if (level > 40) {
      return { color: "orange", icon: <Battery50Icon fontSize="medium" /> };
    } else if (level > 20) {
      return { color: "darkorange", icon: <Battery30Icon fontSize="medium" /> };
    } else if (level > 10) {
      return { color: "red", icon: <Battery20Icon fontSize="medium" /> };
    } else {
      return { color: "darkred", icon: <BatteryAlertIcon fontSize="medium" /> };
    }
  };

  const batteryDetails = getBatteryDetails(batteryValue);

  return (
    <MDTypography variant="caption" fontWeight="medium" color="text">
      {batteryValue !== null && (
        <IconButton color="info">
          <Box
            sx={{
              color: batteryDetails.color,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 15,
            }}
          >
            {batteryDetails.icon}
          </Box>
        </IconButton>
      )}
      {batteryValue == "-1" ? 0 : batteryValue}%
    </MDTypography>
  );
}

CTLBatteryStatus.defaultProps = {
  value: null, 
};

export default CTLBatteryStatus;
